import replace_spaces_for_dashes from "../../Shared/methods/replace_spaces_for_dashes"

export default string => {
  const unique_id = new Date().getTime() + (Math.random() * (1000 - 0) + 0).toFixed(0)

  return `${encodeURIComponent(encodeURI(replace_spaces_for_dashes(string)))}_${unique_id}`
}
